import { StyledButton } from "./styles";
import { ButtonProps } from "../types";

export const Button = ({ color, children, onClick, showShadow = true }: ButtonProps) => (
  <StyledButton color={color} onClick={onClick} showShadow={showShadow}>
    {children}
  </StyledButton>
);
